'use client';

import { styled } from '@mui/material';

const BulletList = styled('ul')(({ theme }) => ({
  marginLeft: '1rem',
  fontSize: '14px',
  marginTop: '0.25rem',
  '> li': {
    marginBottom: '0.25rem',
  },
}));

export default BulletList;
